import { render, staticRenderFns } from "./payment-system.vue?vue&type=template&id=5d703603&scoped=true"
import script from "./payment-system.vue?vue&type=script&lang=js"
export * from "./payment-system.vue?vue&type=script&lang=js"
import style0 from "./payment-system.vue?vue&type=style&index=0&id=5d703603&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d703603",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/payment-system.vue
// module id = b6Z8
// module chunks = 0